import { Tab } from "@headlessui/react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import React, { FC, Fragment,useEffect,useState } from "react";
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import ModalSelectDate from "components/ModalSelectDate";
import moment from "moment";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ModalSelectGuests from "components/ModalSelectGuests";
import { GuestsObject } from "components/HeroSearchForm2Mobile/GuestsInput";
import CardForm from "./CardForm";
import axios from "axios";
import { useParams } from "react-router-dom";
import useAuth from "components/Authprovider/Auth";
import { HotelType } from "data/types";



export interface CheckOutPageProps {
  className?: string;
}

type typeParams = {
    id: any;
  };

interface Booking {
    "id": number,
    "hotel_id": number,
    "user_id": number,
    "number_of_guests": number,
    "number_of_rooms": number,
    "room_type": string,
    "daily_price": number,
    "total_price": number,
    "payment_status": string,
    "booking_status": string,
    "check_in_date": string,
    "check_out_date": string,
    "created_at": string,
    "updated_at": string
}

const CheckOutApp: FC<CheckOutPageProps> = ({ className = "" }) => {
  //////////////////////////////////////////////////////////////////
  const [rangeDates, setRangeDates] = useState<DateRage>({
    startDate: moment().add(1, "day"),
    endDate: moment().add(5, "days"),
  });
  const [guests, setGuests] = useState<GuestsObject>({
    guestAdults: 2,
    guestChildren: 1,
    guestInfants: 1,
  });
  /////////////////////////////////////////////////////////////
  /*Get booking details by the id*/
  const {user} = useAuth()
  const { id } = useParams<typeParams>();

  const [booking,setBooking] = useState<Booking>()
  const [hotel,setHotel] = useState<HotelType>()

  useEffect(() =>{
    const getBooking = async ()=>{
      try {
        const data = await fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/user/'+user!.id+'/bookings/'+id).then((response) => response.json())
        console.log(data)
        if(data && data.status_code === 200){
            const booking = data.data
            console.log(booking)
            setBooking(booking)
        }
      }catch(error){
        throw(error)
      }
      
    }

    const getHotel = async ()=>{
        try {
          const data = await fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+hotel!.id).then((response) => response.json())
          console.log(data)
          if(data && data.status_code === 200){
              const hotels = data.data
              console.log(hotels)
              setHotel(hotels)
          }
        }catch(error){
          throw(error)
        }
        
      }
        getBooking();
        getHotel();
  },[])


  /////////////////////////////////////////////////////////////
  const makePayment = async (token: string) => {

     console.log(token);

      try {
        // 👇️ Create payment using token
        const { data, status } = await axios.post(
          'https://nb-flex.onrender.com/pay',
          { flexresponse: `${token}`, amount: '8', currency: 'USD',clientReference: 'TC50171_3'},
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          },
        );
    
        console.log(JSON.stringify(data, null, 4));
    
        console.log(status);
    
        return data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.log('error message: ', error.message);
          // 👇️ error: AxiosError<any, any>
          return error.message;
        } else {
          console.log('unexpected error: ', error);
          return 'An unexpected error occurred';
        }
      }
  }

  

  const renderSidebar = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-40">
            <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
              <NcImage src={hotel?.image} />
            </div>
          </div>
          <div className="py-5 sm:px-5 space-y-3">
            <div>
              <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1">
                Hotel room in {hotel?.city}, {hotel?.state}
              </span>
              <span className="text-base font-medium mt-1 block">
                {hotel?.name}
              </span>
            </div>
            <span className="block  text-sm text-neutral-500 dark:text-neutral-400">
              2 beds · 2 baths
            </span>
            <div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
            <StartRating reviewCount={hotel?.no_of_reviews}/>
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold">Price detail</h3>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>$19 x 3 day</span>
            <span>$57</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            <span>$0</span>
          </div>

          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold">
            <span>Total</span>
            <span>$57</span>
          </div>
        </div>
      </div>
    );
  };

  const renderMain = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold">
          Confirm and payment
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <div>
            <h3 className="text-2xl font-semibold">Your trip</h3>
            <NcModal
              renderTrigger={(openModal) => (
                <span
                  onClick={() => openModal()}
                  className="block lg:hidden underline  mt-1 cursor-pointer"
                >
                  View booking details
                </span>
              )}
              renderContent={renderSidebar}
              modalTitle="Booking details"
            />
          </div>
          <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
            <ModalSelectDate
              defaultValue={rangeDates}
              onSelectDate={setRangeDates}
              renderChildren={({ openModal }) => (
                <button
                  onClick={openModal}
                  className="text-left flex-1 p-5 flex justify-between space-x-5 "
                  type="button"
                >
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">Date</span>
                    <span className="mt-1.5 text-lg font-semibold">
                      {converSelectedDateToString(rangeDates)}
                    </span>
                  </div>
                  <PencilSquareIcon className="w-6 h-6 text-neutral-6000 dark:text-neutral-400" />
                </button>
              )}
            />

            <ModalSelectGuests
              defaultValue={guests}
              onChangeGuests={setGuests}
              renderChildren={({ openModal }) => (
                <button
                  type="button"
                  onClick={openModal}
                  className="text-left flex-1 p-5 flex justify-between space-x-5"
                >
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">Guests</span>
                    <span className="mt-1.5 text-lg font-semibold">
                      <span className="line-clamp-1">
                        {`${
                          (guests.guestAdults || 0) +
                          (guests.guestChildren || 0)
                        } Guests, ${guests.guestInfants || 0} Infants`}
                      </span>
                    </span>
                  </div>
                  <PencilSquareIcon className="w-6 h-6 text-neutral-6000 dark:text-neutral-400" />
                </button>
              )}
            />
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-semibold">Pay with</h3>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>

          <div className="mt-6">
            <Tab.Group>
              <Tab.List className="flex my-5">
                {/*<Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-full focus:outline-none ${
                        selected
                          ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900"
                          : "text-neutral-6000 dark:text-neutral-400"
                      }`}
                    >
                      Pay at premise
                    </button>
                  )}
                  </Tab>*/}
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5  rounded-full flex items-center justify-center focus:outline-none  ${
                        selected
                          ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900"
                          : " text-neutral-6000 dark:text-neutral-400"
                      }`}
                    >
                      <span className="mr-2.5">Credit card</span>
                      <img className="w-8" src={visaPng} alt="" />
                      <img className="w-8" src={mastercardPng} alt="" />
                    </button>
                  )}
                </Tab>
              </Tab.List>

              <Tab.Panels>
              {/*<Tab.Panel className="space-y-5">
                  <div className="space-y-1">
                    <Label>Name </Label>
                    <Input type="email" defaultValue="" />
                    <span className="text-sm text-neutral-500 block">
                      This name will be used by hosts to register you.
                    </span>
                  </div>
                  <div className="space-y-1">
                    <Label>Number </Label>
                    <Input type="telephone" defaultValue="09" />
                    <span className="text-sm text-neutral-500 block">
                      Use a working telephone number for you to be contacted.
                    </span>
                  </div>
                  <div className="space-y-1">
                    <Label>Messager for host </Label>
                    <Textarea placeholder="..." />
                    <span className="text-sm text-neutral-500 block">
                      Write a few sentences on information host have to know beforehand.
                    </span>
                  </div>
                    </Tab.Panel>*/}

                <Tab.Panel className="space-y-5">
                  <CardForm captureContextUrl="https://nb-flex.onrender.com/checkout" onError={(e)=> console.log(e)} onToken={makePayment}/>
                </Tab.Panel>
                
              </Tab.Panels>
            </Tab.Group>
            <div className="pt-8">
              <ButtonPrimary href={"/pay-done"}>Confirm and pay</ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-CheckOutPage ${className}`} data-nc-id="CheckOutPage">
      <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10 ">{renderMain()}</div>
        <div className="hidden lg:block flex-grow">{renderSidebar()}</div>
      </main>
    </div>
  );
};

export default CheckOutApp;
